import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import { IAbTestingData } from "./ab_testing_service_interface";
import { SYSTEM_EVENTS } from '../../events/events';
import IAbTestingService from './ab_testing_service_interface';
import { IAbTestingFeatureProperties } from './ab_testing_service_interface';
import Store from '../../utils/store';

const AB_TESTING_DATA_LOCAL_STORAGE_KEY = "ABTestingDataForUser";

export default class AbTestingService extends BaseService implements IAbTestingService {

    static CLASS = 'AbTestingService';

    private _cachedABTestingData: IAbTestingData;

    public init(): void {
        this._resetCache();
        this._subscribe();
    }

    onInitializationCompleted(): Promise<any> {
        this._readAbTestingDataFromToken();
        return super.onInitializationCompleted();
    }

    private _subscribe(): void {
        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            this._resetCacheData();
        });
    }

    private _resetCacheData(): void {
        this._resetCache();
        this._readAbTestingDataFromToken();
    }

    private _resetCache(): void {
        this._cachedABTestingData = {
            ErrorDescription: null,
            Features: {}
        };
    }

    getAbTestingDataForFeature(featureName: string): IAbTestingFeatureProperties {
        if (this._cachedABTestingData?.Features) {
            const feature: IAbTestingFeatureProperties = this._cachedABTestingData.Features[featureName];
            if (feature?.Properties) {
                if(feature.Properties.featureToggle){
                    const toggle: string = feature.Properties.featureToggle.toString().toLowerCase();
                    if(toggle === "false") return null;
                }
                return feature;
            }
        }
        return null;
    }

    getAbTestingData(): { [key: string]: IAbTestingFeatureProperties } {
        if (this._cachedABTestingData?.Features && !this._cachedABTestingData.ErrorDescription) {
            const result: { [key: string]: IAbTestingFeatureProperties } = {};
            for (const featureName in this._cachedABTestingData.Features) {
                result[featureName] = this.getAbTestingDataForFeature(featureName);
            }
            return result;
        } else {
            return null;
        }
    }

    private _readAbTestingDataFromToken(): void {
        const abTestingDataTokenProperty = this.serviceFactory.oAuth2Service().extractTokenProperty('abTestingData');
        if (abTestingDataTokenProperty) {
            this._cachedABTestingData = _.safeJSON(abTestingDataTokenProperty);
            this._saveLocalStorageABTestingData();
        } else {
          const localStorageABTestingData = this._getLocalStorageABTestingData();
          if(localStorageABTestingData){
              this._cachedABTestingData = localStorageABTestingData;
          }
        }
    }

    private _saveLocalStorageABTestingData(): void {
        const abTestingData = this._cachedABTestingData;
        if (abTestingData && !abTestingData.ErrorDescription) {
          Store.set(AB_TESTING_DATA_LOCAL_STORAGE_KEY, JSON.stringify(abTestingData));
        }
    }

    private _getLocalStorageABTestingData(): IAbTestingData {
        return JSON.parse(Store.get(AB_TESTING_DATA_LOCAL_STORAGE_KEY, null));
    }
}
